/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-07-09 17:18:59
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-11 14:39:15
 */
export const BlueText: React.FC<{ children?: any }> = ({ children }) => {
	return <span style={{ color: "#565BDD" }}>{children}</span>;
};
